import type { IObjectAny } from '@customTypes/utility'

const isValidArray = (arr: unknown): arr is readonly unknown[] =>
	Array.isArray(arr) && arr.length > 0

const traverseAndSum = (arr: readonly IObjectAny[], objKey: string): number => {
	if (arr.length === 0) {
		return 0
	}
	return arr.length > 1
		? arr?.map(item => item[objKey]).reduce((prev, curr) => prev + curr, 0)
		: arr[0][objKey]
}

export { isValidArray, traverseAndSum }
